import { Box } from '@mui/material';
import Seo from '../components/Seo';
import HeroSection from '../components/HomePage/HeroSection';
import ModulesSection from '../components/HomePage/ModulesSection';
import KeyFeaturesSection from '../components/HomePage/KeyFeaturesSection';
import CompatibilitySection from '../components/HomePage/CompatibilitySection';
import RegionsSection from '../components/HomePage/RegionsSection';
import ConnectStrip from '../components/HomePage/ConnectStrip';
import PricingSection from '../components/HomePage/PricingSection';
import ClientsSection from '../components/HomePage/ClientsSection';

const HomePage = () => {
  return (
    <Box>
      <Seo
        title="SOLVENDA — Complete ISP Management Solution | Billing, Radius, OLT & Payments"
        description="SOLVENDA is a complete management solution for Internet Service Providers: billing, customers, FreeRadius internet, ZTE OLT management, fiscalization, DNS, log retention and online card payments. Pay only for what you use, from €50/month."
        keywords="ISP management, ISP billing, FreeRadius, OLT management, ZTE OLT, fiscalization Albania, online payments ISP, IPTV management, DNS filtering, log retention, Albania ISP software"
        path="/"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: 'SOLVENDA',
          url: 'https://solvenda.org',
          inLanguage: 'en',
          publisher: { '@type': 'Organization', name: 'SOLVENDA' },
        }}
      />
      <HeroSection />
      <ModulesSection />
      <KeyFeaturesSection />
      <CompatibilitySection />
      <RegionsSection />
      <ConnectStrip />
      <PricingSection />
      <ClientsSection />
    </Box>
  );
};

export default HomePage;
